export default function formattedPhone (value, type = '') {
  return value.replace(/(\d{2})(\d{4})(\d{3})(\d{3})/, '$1 $2 $3 $4')
}
